/** Decision family names as chips and sentences say them: the catalog's desk labels, read once where the catalog is loaded (the frame, the solo pages) and handed down by context. */
import { createContext, useContext, type ReactNode } from "react";
import type { ContentCatalog } from "@bsim/contracts";
import { deskLabeler, type DeskLabeler } from "../decisions/labels";

const DeskLabels = createContext<DeskLabeler>(deskLabeler(undefined));

export const useDeskLabel = (): DeskLabeler => useContext(DeskLabels);

export function DeskLabelProvider({ catalog, children }: { readonly catalog: Pick<ContentCatalog, "desks"> | undefined; readonly children: ReactNode }) {
  return <DeskLabels value={deskLabeler(catalog)}>{children}</DeskLabels>;
}
